import ReferralBanner from "./ReferralBanner";

export default ReferralBanner;
